import { DocumentTextIcon, PencilSquareIcon } from "@heroicons/react/24/solid";
import { useEffect, useRef, useState } from "react";
import { useQueryClient } from "react-query";
import { useHistory, useLocation } from "react-router-dom";
import { useRecoilState, useRecoilValue } from "recoil";
import { notificationFilterById } from "../../../../actions/Utilities/NotificationFilter";
import AddButton from "../../../../components/AddButton";
import ConfirmBoxDelete from "../../../../components/ConfirmBoxDelete";
import EditButton from "../../../../components/EditButton";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import { toast } from "../../../../components/toastNotification";
import { mainSelectedTab } from "../../../CarrierAgreementMgmt/atoms";
import {
  selectedModule,
  selectedReports,
} from "../../../CarrierAgreementMgmt/ReportsDynamic/DynamicReports/atoms";
import { SideBarData } from "../../../CarrierAgreementMgmt/ReportsDynamic/SideBarData";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { PERMISSIONS } from "../../../PermissionsConstants";
import {
  addCustomReport,
  editCustomReport,
  rowForEditCustomReport,
  runCustomQuery,
  isRunCustomQuery,
  isSelectedModule,
  selectedColumn,
  addNewReport,
  selectedRowsCustomToDelete,
} from "../atom/atoms";
import CustomReportForm from "../forms/CustomReportForm";
import useDeactivateCustomReport from "../hooks/useDeactivateCustomReport";
import { useGetCustomReports } from "../hooks/useGetCustomReports";
import useGetDetailsForEdit from "../hooks/useGetDetailsForEdit";
import TableFilters from "../TableFilters";
import { ICustomReportDetails } from "../types";

interface CustomReportTableProp {}

const CustomReportTable: React.FC<CustomReportTableProp> = ({}) => {
  const addPermission = PERMISSIONS.permission_utilities_customreport_add;
  const editPermission = PERMISSIONS.permission_utilities_customreport_edit;
  const deletePermission = PERMISSIONS.permission_utilities_customreport_delete;

  const [customData, setCustomData] = useState<any[]>([]);
  const [filterCustomData, setFilterCustomData] = useState<any[]>([]);
  const user = useRecoilValue(accountAtom);
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const tableRef = useRef<any>(0);
  const [isAddState, setIsAddState] = useRecoilState(addCustomReport);
  const [rowForEdit, setRowForEdit] = useRecoilState(rowForEditCustomReport);
  const [, setIsSelectModule] = useRecoilState(isSelectedModule);
  const [isEditState, setIsEditState] = useRecoilState(editCustomReport);
  const [, setCustomQuery] = useRecoilState(runCustomQuery);
  const [, setIsRunQuery] = useRecoilState(isRunCustomQuery);
  const [, setSelectedColumns] = useRecoilState<any>(selectedColumn);
  const [, setIsAddnewReport] = useRecoilState(addNewReport);
  const [isFromReport, setIsFromReport] = useState(false);
  const [, setModuleName] = useRecoilState(selectedModule);
  const [, setSelectedReport] = useRecoilState(selectedReports);
  const [openModalDelete, setOpenModalDelete] = useState(false);
  const [selectedRowsToDelete, setSelectedRowsToDelete] = useRecoilState(
    selectedRowsCustomToDelete
  );
  const [filterText, setFilterText] = useState("");
  const [isSearching, setIsSearching] = useState(false);
  const [isFromRecent, setIsFromRecent] = useState(false);
  const [customReportId, setcustomReportId] = useState("");
  const queryClient = useQueryClient();
  const { memResult: reportsTabs } = SideBarData();
  const { data: customReports, isFetching: customReportsLoading } =
    useGetCustomReports();
  const { mutate: ForEdit } = useGetDetailsForEdit();
  const {
    mutate: BulkDeactivateReports,
    isSuccess: deacSuccess,
    data: deacResult,
    reset: resetDeacData,
  } = useDeactivateCustomReport();

  useEffect(() => {
    if (customReports?.status === 200) {
      setCustomData(customReports?.data?.map((data) => ({ ...data })));
    } else {
      setCustomData([]);
    }
  }, [customReports, setCustomData]);

  let recordIdFromRecent;
  let location = useLocation();
  const history = useHistory();

  if (location.state !== null) {
    recordIdFromRecent = location.state;
  }

  useEffect(() => {
    setCustomQuery({
      label: "",
      value: "",
      tableColumns: "",
      condition: [],
      script: "",
      moduleName: "",
      orderBy: "",
    });
    setIsRunQuery(false);
    setIsAddState(false);
    setIsEditState(false);
    setIsSelectModule(false);
    setSelectedColumns([]);
    setRowForEdit(undefined);
    setFilterCustomData([]);
    setIsFromRecent(false);
    setFilterText("");
  }, []);

  useEffect(() => {
    if (recordIdFromRecent) {
      try {
        notificationFilterById(
          recordIdFromRecent.recordId,
          recordIdFromRecent.moduleName,
          recordIdFromRecent.subModuleName
        ).then((result) => {
          const ids = result?.map((c) => c.id).join(".");
          setcustomReportId(ids);
          setIsFromRecent(true);
        });
      } catch (error) {}
    } else {
      localStorage.removeItem("NotifFilter");
      localStorage.removeItem("ModuleFilter");
    }
  }, [recordIdFromRecent]);

  useEffect(() => {
    if (recordIdFromRecent?.action === "addNewReport") {
      setIsFromReport(true);
      setModuleName(recordIdFromRecent.module);
      setSelectedReport(recordIdFromRecent.reportName);
    }
  }, []);

  useEffect(() => {
    if (isFromReport) {
      setIsAddState(true);
      setIsAddnewReport(true);
      setIsFromReport(false);
    }
    if (
      isFromRecent &&
      customReportId !== "" &&
      customReports?.data?.length > 0
    ) {
      if (customReportId.includes(".")) {
        let ids = customReportId?.split(".");
        const mappedIds = ids?.map((s) => Number(s));
        const filteredData = customReports?.data?.filter((x) =>
          mappedIds.includes(x.id)
        );

        setFilterCustomData(filteredData);
      } else {
        const filteredData = customReports?.data?.filter(
          (x) => x.id === Number(customReportId)
        );
        setFilterCustomData(filteredData);
      }
    }
  }, [isFromReport, isFromRecent, customReportId, customReports?.data]);

  useEffect(() => {
    if (filterText !== "" && filterCustomData?.length > 0 && isSearching) {
      const filteredData = filterCustomData?.filter((x) =>
        x.reportName?.toLowerCase()?.includes(filterText?.trim()?.toLowerCase())
      );
      if (filteredData?.length > 0) {
        setFilterCustomData(filteredData);
      } else {
        setFilterCustomData([]);
      }
      setIsSearching(false);
    }
    if (filterText !== "" && isSearching && customData?.length > 0) {
      const filteredData = customData?.filter((x) =>
        x.reportName?.toLowerCase()?.includes(filterText?.trim()?.toLowerCase())
      );
      if (filteredData?.length > 0) {
        setFilterCustomData(filteredData);
      }
    }
  }, [filterCustomData, filterText, isSearching, customData]);

  const handleEdit = (rowData: ICustomReportDetails) => {
    ForEdit(rowData.id, {
      onSuccess: (res: ICustomReportDetails) => {
        const fields = res?.customFields?.map((item, index) => {
          return {
            ...item,
            logic: index > 0 ? item.logic : "AND",
            parentRow: index > 0 ? false : true,
            tableName: "customFields",
          };
        });
        const permission: any = res?.permissionIds?.map((x) => {
          return {
            value: x.roleId,
            label: x.roleName,
            customReportId: x.customReportId,
            id: x.id,
          };
        });
        const permi = permission?.filter((c) => c.value === user?.roleId);

        if (permi?.length === 0) {
          const newPermission = {
            value: user?.roleId,
            label: user?.roleName,
            customReportId: res.id,
            id: 0,
          };
          permission.push(newPermission);
        }

        setSelectedColumns(res?.selectedColumns);
        setRowForEdit({
          ...res,
          customFields: fields,
          permissionIds: permission,
          status: res.isActive,
        });
      },
    });

    setIsEditState(true);
    setIsSelectModule(true);
  };

  const Redirection = (rowData) => {
    history.push({
      pathname: rowData?.path,
    });
    localStorage.setItem("Reports", "FromCustomReport");
    window.location.reload();
    let userTabs: any = [];

    reportsTabs.forEach((tabs, index) => {
      let temp = tabs?.subNav?.filter((c) => c.to === rowData?.path);

      if (temp.length > 0)
        userTabs.push({
          to: tabs.path,
          index: index, // Add index to the object pushed to userTabs
        });
    });

    setModuleName(rowData?.moduleName?.toUpperCase());
    setSelectedIndex(userTabs[0]?.index);
  };

  const handleSelectedRowsChange = (rows) => {
    const forDelete = rows
      .filter((x) => x.isActive)
      .map((r) => {
        const { tableData, ...rows } = r;
        return rows;
      });
    setSelectedRowsToDelete(forDelete);
  };
  const handleBulkDelete = () => {
    const ids = selectedRowsToDelete?.map((row) => row.id);
    BulkDeactivateReports(ids);
    setOpenModalDelete(false);
    setSelectedRowsToDelete([]);
  };

  const deleteMessage = (
    <div className="text-gray-500 font-normal">{`Are you sure you want to deactivate ${
      selectedRowsToDelete?.length
    } ${
      selectedRowsToDelete
        ? selectedRowsToDelete?.length > 1
          ? "Reports"
          : "Report"
        : ""
    }?`}</div>
  );

  if (deacSuccess && deacResult) {
    if (deacResult.status === 201 || deacResult.status === 200) {
      toast.fire("Success", "Reports were deactivated successfully", "success");
      queryClient.invalidateQueries("GetCustomReports");
    } else if (deacResult.status === 500) {
      toast.fire(
        "Warning",
        "Report were successfully deactivated, but " + deacResult.data.message,
        "warning"
      );
    } else {
      toast.fire(
        "Bulk deactivation of Report failed",
        "Server Error: Cannot deactivate Report",
        "error"
      );
      queryClient.invalidateQueries("GetCustomReports");
    }
    resetDeacData();
  }
  const alignCenter = "center" as
    | "center"
    | "inherit"
    | "justify"
    | "left"
    | "right"
    | undefined;
  const matColumns = [
    {
      title: "Report Name",
      field: "reportName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              localStorage.setItem(
                "CustomReportPage",
                tableRef?.current?.dataManager?.currentPage
              );
              Redirection(rowData);
            }}
          >
            <span className="blueAndBold underline">{rowData.reportName}</span>
          </div>
        );
      },
    },
    {
      title: "Location",
      field: "moduleName",
    },
    {
      title: "Created By",
      field: "createdBy",
    },
    {
      title: "Created Date",
      field: "createdDate",
      render: (rowData) => {
        return (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.createdDate
                ? new Date(rowData.createdDate).toLocaleDateString()
                : ""}
            </div>
          </div>
        );
      },
    },
    {
      title: "Modified By",
      field: "modifiedBy",
    },
    {
      title: "ModifiedBy Date",
      field: "modifiedDate",
      render: (rowData) => {
        return (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.modifiedDate
                ? new Date(rowData.modifiedDate).toLocaleDateString()
                : ""}
            </div>
          </div>
        );
      },
    },
    {
      title: "Status",
      field: "isActive",
      render: (rowData) => {
        return (
          <div>
            <div className="font-sans text-left mr-4 text-xs">
              {rowData.isActive ? "Active" : "Inactive"}
            </div>
          </div>
        );
      },
    },
    {
      title: "Actions",
      sorting: false,
      align: alignCenter,
      render: (rowData) => {
        return !userPermissions.includes(editPermission) ? (
          ""
        ) : (
          <div className="flex justify-center">
            <EditButton
              disabled={selectedRowsToDelete?.length ? true : false}
              className={
                selectedRowsToDelete?.length
                  ? "opacity-50 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary "
                  : "opacity-100 rounded-full items-center bg-quaternary  text-white hover:bg-hquaternary"
              }
              onClick={() => {
                handleEdit(rowData);
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <>
      <div className="animate-fade-in-down bg-white space-y-3 px-8 py-4">
        {isAddState || (isEditState && rowForEdit) ? (
          <CustomReportForm />
        ) : (
          <>
            <div className="w-full">
              <div className="flex gap-2 items-center">
                <div>
                  <DocumentTextIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
                </div>
                <div className="flex flex-col leading tight">
                  <h3 className="text-xs font-medium text-gray-500">
                    Utilities Module
                  </h3>
                  <h1 className="mr-auto font-bold text-primary text-md uppercase">
                    Custom Report
                  </h1>
                </div>
              </div>
              <div className="h-0.5 w-full border-b-2 border-secondary mt-2 mb-4" />
              <div className="mt-4 rounded-md">
                <div className="flex justify-between text-xs items-center w-full">
                  <TableFilters
                    moduleDetails="Reports Name"
                    textInputName="reportsName"
                    disabledButton={
                      selectedRowsToDelete !== undefined &&
                      selectedRowsToDelete.length > 0
                    }
                    setFilterText={setFilterText}
                    setIsSearching={setIsSearching}
                    setIsFromRecent={setIsFromRecent}
                    isFromRecent={isFromRecent}
                    setFilterCustomData={setFilterCustomData}
                  />
                  {userPermissions.includes(addPermission) && (
                    <AddButton
                      disabled={
                        selectedRowsToDelete !== undefined &&
                        selectedRowsToDelete.length > 0
                      }
                      buttonText="New Custom Report"
                      onClick={() => {
                        setIsAddState(true);
                      }}
                    />
                  )}
                </div>
                <div>
                  {userPermissions.includes(deletePermission) ? (
                    <div className="text-secondary italic text-xs3 my-2">
                      <p className="font-bold italic inline-block mr-1">
                        Note:
                      </p>
                      <span>Tick the box to deactivate some data.</span>
                    </div>
                  ) : (
                    <div className="mb-4"></div>
                  )}
                </div>
              </div>
              <div className="">
                <MaterialTableTS
                  columns={matColumns}
                  data={
                    filterCustomData?.length > 0 ? filterCustomData : customData
                  }
                  isLoading={isSearching ? isSearching : customReportsLoading}
                  tableRef={tableRef}
                  selection={userPermissions.includes(deletePermission)}
                  onSelectionChange={handleSelectedRowsChange}
                  selectedRows={selectedRowsToDelete}
                  setConfirmModalOpen={setOpenModalDelete}
                />
              </div>
            </div>
          </>
        )}
      </div>
      <ConfirmBoxDelete
        ModalTitle="Deactivate Report"
        qConfirmation={deleteMessage}
        isOpen={openModalDelete}
        onClose={() => setOpenModalDelete(false)}
        onClickFunction={handleBulkDelete}
        cancelButtonRef={undefined}
      />
    </>
  );
};

export default CustomReportTable;
